import React, { useState } from 'react';
import {
    Box,
    Button,
    Typography,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Snackbar,
    Alert,
    CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import LandinagPage from './page';

const NotificationForm = () => {
    const [open, setOpen] = useState(true);
    const [dateTime, setDateTime] = useState(dayjs().add(1, 'minute')); // default to now + 1 min
    const [message, setMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarError, setSnackbarError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!message.trim()) {
            alert('Please enter a message.');
            return;
        }

        const now = dayjs();
        if (dateTime.isBefore(now)) {
            alert('Scheduled time must be in the future.');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                'https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/add_notification',
                {
                    message,
                    dateTime: dateTime.toISOString(),
                }
            );
            console.log('API response:', response.data);
            setSnackbarOpen(true);
            setOpen(false);
        } catch (error) {
            console.error('API call failed:', error);
            setSnackbarError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <LandinagPage />

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#b2ebf2' }}
                >
                    <Typography variant="h6">Schedule Notification</Typography>
                    <IconButton onClick={() => setOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={3}>
                        <Box>
                            <Typography fontWeight={600} mb={1}>
                                Select Date & Time:
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={dateTime}
                                    onChange={(newValue) => newValue && setDateTime(newValue)}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                    minDateTime={dayjs().add(1, 'minute')}
                                />
                            </LocalizationProvider>
                        </Box>

                        <Box>
                            <Typography fontWeight={600} mb={1}>
                                Message:
                            </Typography>
                            <TextField
                                multiline
                                minRows={6}
                                fullWidth
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Enter your notification message here"
                                sx={{ background: '#f8f9fc', borderRadius: 2 }}
                            />
                        </Box>

                        <Box display="flex" justifyContent="flex-end" alignItems="center">
                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={loading}
                                sx={{ background: 'linear-gradient(to right, #0575e6, #021b79)' }}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Success Snackbar */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }}>
                    Notification scheduled successfully!
                </Alert>
            </Snackbar>

            {/* Error Snackbar */}
            <Snackbar
                open={snackbarError}
                autoHideDuration={4000}
                onClose={() => setSnackbarError(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbarError(false)} severity="error" sx={{ width: '100%' }}>
                    Failed to schedule notification. Please try again.
                </Alert>
            </Snackbar>
        </>
    );
};

export default NotificationForm;
